import * as createRavenMiddleware from 'raven-for-redux';
import * as Raven from 'raven-js';
import { IState } from '../reducers';

const ravenMiddleware = () => {
  const options: createRavenMiddleware.RavenMiddlewareOptions<any> = {
    breadcrumbDataFromAction: (action: { payload: any; type: string }) => {
      const payloadString = JSON.stringify(action.payload);

      return {
        data: payloadString ? payloadString.substring(0, 180) : null,
      };
    },
    getUserContext: ({ user: { userId, mobile } }: IState) => ({
      id: userId,
      username: mobile || undefined,
    }),
  };

  return createRavenMiddleware(Raven, options);
};

export default ravenMiddleware();



// WEBPACK FOOTER //
// ./src/store/middleware/raven.ts